module.exports = __webpack_public_path__ + "img/insta2.9a27d087.jpg";